import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminAgreementFeed = lazy(() => import("@/pages/admin/AdminAgreementFeed"));

export const Route = createFileRoute("/admin/avtals-api")({
  component: () => <AdminAgreementFeed />,
});
